import './index.css'
import './utils/disableOverlay'

import App from './App.vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { errorHandler } from './services/error/errorHandler'
import { logger } from './utils/logger'
import router from './router/index'
import { validateConfig } from './utils/configValidator'
import { initializeTokenRefresh } from './services/auth/authentikAuth'
import authConfig from './config/authConfig'
import type { AuthentikWindow } from './types/common'

// Validate configuration before starting the application
validateConfig()

// Set Authentik configuration globally on window
// This ensures token refresh works on any page, not just after login
const authentikWindow = window as AuthentikWindow
authentikWindow.authentikClientId = authConfig.authentikClientId || ''
authentikWindow.authentikAuthorizationEndpoint = authConfig.authentikAuthorizationEndpoint || ''
authentikWindow.authentikTokenEndpoint = authConfig.authentikTokenEndpoint || ''
authentikWindow.authentikUserInfoEndpoint = authConfig.authentikUserInfoEndpoint || ''
authentikWindow.authentikLogoutEndpoint = authConfig.authentikLogoutEndpoint || ''
authentikWindow.authentikScope = authConfig.authentikScope || ''

// Init function
async function init() {
  // Create the app instance
  const app = createApp(App)

  // Initialize Pinia
  const pinia = createPinia()
  app.use(pinia)

  // Initialize router
  app.use(router)

  // Initialize token refresh scheduling
  // This ensures refresh timeouts are restored after page reload
  initializeTokenRefresh()

  // Global error handler
  app.config.errorHandler = (error, instance, info) => {
    logger.error('Global error:', { error, instance, info })
    errorHandler.setError(error, 'Global Vue Error')
  }

  // Mount the app
  app.mount('#app')
}

// Start the application
init()
